/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SEO from "../components/common/seo";
import { persistor } from "../store";
import { selectUserProfile } from "../store/auth/selector";
import { loginStyle } from "../styles/container/login";
import { logoutMicrosoftRedirect } from "../utils/new-azure-ad";
import { cleanupStorage, getAuthToken } from "../utils/storage";

export function Logout() {
  const navigate = useNavigate();
  const authToken = getAuthToken();
  const profile = useSelector(selectUserProfile);

  useEffect(() => {
    const performLogout = async () => {
      const shouldBypass = !authToken || !profile;

      if (shouldBypass) {
        await Promise.all([persistor.purge(), cleanupStorage()]);
        navigate("/login", { replace: true });
        return;
      }

      await Promise.all([persistor.purge(), cleanupStorage()]);

      await new Promise((resolve) => {
        setTimeout(resolve, 2000);
      });

      if (profile?.BypassActorBinusianId) {
        navigate("/login", { replace: true });
      } else {
        await logoutMicrosoftRedirect();
      }
    };

    performLogout();
  }, []);

  return (
    <>
      <SEO />
      <Container maxWidth={false} disableGutters>
        <Stack
          component="section"
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{
            ...loginStyle.contentStack,
            height: { xs: "500px", sm: "520px" },
            flexDirection: "column",
            gap: 0,
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "700",
              fontSize: "24px",
              color: "white",
              marginBottom: "4px",
            }}
          >
            Logout is in progress.
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "white",
              fontSize: "18px",
              maxWidth: "80%",
            }}
          >
            We will immediately redirect you to the login page...
          </Typography>
        </Stack>
      </Container>
    </>
  );
}
